import axios from 'axios'
import store from '@/store'
import Router from '@/router/index'
import { refresh } from '@/api/auth'
import {
  getInterceptorsRequest,
  errorToast,
  reqErr,
  resolveGetMethod,
  whiteApi
} from './req.config'
import { Tracker } from '@/service'

function createAxios (inst, isJson = true) {
  inst = inst || axios.create()
  inst.defaults.timeout = process.env.NODE_ENV === 'production' ? 10000 : 30 * 1000
  inst.defaults.baseURL = inst.defaults.baseURL || process.env.VUE_APP_BASE_API || '/'
  inst.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  let config = getInterceptorsRequest(isJson)
  inst.interceptors.request.use(config)

  // 是否正在刷新的标记
  let isRefreshing = false
  // 重试队列，每一项将是一个待执行的函数形式
  let requests = []
  inst.interceptors.response.use(
    (res) => {
      const {
        data,
        status,
        config: { showError }
      } = res
      if (status === 200) {
        // console.log('Tracker-config',res)
        // console.log('Tracker-config',config.data)
        Tracker.apiTracker({
          apiUrl: res.config.url,
          res: data,
          query: res.config.params,
          type: res.config.method
        })
        if (whiteApi.indexOf(res.config.url) > -1) return data
        if (data.data) return data.data
        if (showError) {
          if (data.errcode == 40103) {
            // token过期，刷新token，重新请求接口
            const config = res.config
            if (!isRefreshing) {
              isRefreshing = true
              return refresh()
                .then((data) => {
                  const { token } = data
                  store.dispatch('setToken', { token })
                  config.headers['Authorization'] = 'Bearer ' + token
                  // 已经刷新了token，将所有队列中的请求进行重试
                  requests.forEach((cb) => cb(token))
                  // 重试完了清空这个队列
                  requests = []
                  return inst(config)
                })
                .catch(() => {
                  Router.push({ path: '/auth/login', replace: true })
                })
                .finally(() => {
                  isRefreshing = false
                })
            } else {
              // 正在刷新token，返回一个未执行resolve的promise
              return new Promise((resolve) => {
                // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                requests.push((token) => {
                  store.dispatch('setToken', { token })
                  config.headers['Authorization'] = 'Bearer ' + token
                  resolve(inst(config))
                })
              })
            }
          } else {
            errorToast(data)
          }
          return Promise.reject(data)
        }
      }

      return Promise.reject(reqErr(res))
    },
    (err) => {
      //
      console.log('req-err', err)
      err.response && errorToast(err.response.data.error)

      return Promise.reject(err)
    }
  )

  resolveGetMethod(inst)
  return inst
}

export default createAxios()

export { createAxios }
